import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import styled from 'styled-components';
import Button from 'monday-ui-react-core/dist/Button';
import TextField from 'monday-ui-react-core/dist/TextField';

import { useMutation, useQueryClient } from 'react-query';
import { createNewColumn } from '../../services/monday';

import UpdatedDialog from '../UpdatedDialog';
import { addColumnSchemas } from '../../form-schemas';
import { useParams } from 'react-router-dom';

const DialogBodyContainer = styled.div`
  padding-bottom: 2rem;
  display: flex;
  justify-content: start;
  flex-direction: column;

  .label-component--wrapper {
    padding-bottom: 0px !important;
  }
`;

const Title = styled.h1`
  margin-bottom: 1rem;
  overflow-wrap: break-word;
  font-size: 1.5rem;
  line-height: 2rem;
`;

const TextLabel = styled.span`
  font-size: 14px;
  .required {
    color: red;
  }
`;

const ActionContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const SubmitButton = styled(Button)`
  margin-top: 1.5rem;
  width: 100%;
`;

const AddColumnDialogue = ({
  handleClose,
  type,
  boardId,
  createFunction = createNewColumn,
}) => {
  const { itemId } = useParams();
  const { mutate, isLoading: isAddingColumn } = useMutation(createFunction);

  const queryClient = useQueryClient();
  const {
    handleSubmit,
    control,
    formState: { errors },
    watch,
  } = useForm({
    mode: 'onSubmit',
    defaultValues: {
      columnName: '',
    },
    resolver: yupResolver(addColumnSchemas),
  });

  return (
    <UpdatedDialog
      handleClose={handleClose}
      minWidth="fit-content"
      dialogBody={
        <DialogBodyContainer>
          <Title>Add new {type} column</Title>
          <form
            onSubmit={handleSubmit((data) => {
              mutate(
                {
                  boardId,
                  columnType: type,
                  columnName: watch('columnName'),
                  itemId,
                },
                {
                  onSuccess: async (res) => {
                    queryClient.invalidateQueries('get-columns');
                    handleClose();
                  },
                },
              );
            })}
          >
            <Controller
              name="columnName"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  title={
                    <TextLabel>
                      Column Name <span className="required">*</span>
                    </TextLabel>
                  }
                  placeholder="Column Name"
                  validation={{
                    status: errors?.columnName ? 'error' : '',
                    text: errors?.columnName?.message,
                  }}
                  {...field}
                />
              )}
            />

            <ActionContainer>
              <SubmitButton
                size={Button.sizes.MEDIUM}
                kind={Button.kinds.PRIMARY}
                type={Button.types.SUBMIT}
                form="hook-form"
                loading={isAddingColumn}
              >
                Add to board
              </SubmitButton>
            </ActionContainer>
          </form>
        </DialogBodyContainer>
      }
    />
  );
};

export default AddColumnDialogue;
